module.exports = __webpack_public_path__ + "img/Picture6.6d96d37d.png";